// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__ncsde","left":"Virtual_left__b7c0C","wrapper":"Virtual_wrapper__Jta+d"};